export const MarketplaceType = {
  MPAC: 'MPAC',
  EMCEE: 'EMCEE'
};